import { render, staticRenderFns } from "./resumo-docs-rejeitados.vue?vue&type=template&id=53bb92dc&scoped=true"
import script from "./resumo-docs-rejeitados.vue?vue&type=script&lang=js"
export * from "./resumo-docs-rejeitados.vue?vue&type=script&lang=js"
import style0 from "./resumo-docs-rejeitados.vue?vue&type=style&index=0&id=53bb92dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bb92dc",
  null
  
)

export default component.exports